//changes from haseeb.

import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { UsePortalApi } from "../../../utils/UsePortalApi";

export const PatientUpdate = createAsyncThunk(
  "PatientUpdate",
  async (payload, { dispatch, getState }) => {
    try {
      dispatch(gettingPatientUpdate(""));
      const response = await UsePortalApi(
        `PatientUpdate`,
        "Post",
        payload,
        true
      );
      if (response) {
        console.log(response , "response")
         dispatch(gettingPatientUpdateSuccess(response))

      } else {
        dispatch(
          gettingPatientUpdateFailed(
            response?.errorMessage
          )
        );
      }
    } catch (error) {
      dispatch(gettingPatientUpdateFailed(error));
    }
  }
);
const PatientUpdateSlice = createSlice({
  name: "PatientUpdate",
  initialState: {
    PatientUpdateData: null,
    isPatientUpdateData: false,
    isPatientUpdateError: false,
  },
  reducers: {
    gettingPatientUpdate: (state, action) => {
      state.PatientUpdateData = null;
      state.isPatientUpdateData = true;
      state.isPatientUpdateError = false;
    },
    gettingPatientUpdateSuccess: (state, action) => {
      state.PatientUpdateData = action.payload;
      state.isPatientUpdateData = false;
      state.isPatientUpdateError = false;
    },
    gettingPatientUpdateFailed: (state, action) => {
      state.PatientUpdateData = null;
      state.isPatientUpdateData = false;
      state.isPatientUpdateError = true;
    },
    gettingPatientUpdateClear: (state, action) => {
      state.PatientUpdateData = null;
      state.isPatientUpdateData = false;
      state.isPatientUpdateError = false;
    },
  },
});
export const {
  gettingPatientUpdate,
  gettingPatientUpdateSuccess,
  gettingPatientUpdateFailed,
  gettingPatientUpdateClear,
} = PatientUpdateSlice.actions;
export default PatientUpdateSlice.reducer;
